export const analytics = {
  title: "Analysen",
  subtitle: "Einnahmen und Auslastung deiner Unterkünfte im gewählten Zeitraum.",
  tabs: {
    performance: "Leistung",
    channels: "Kanäle",
  },
  allAccommodations: "Alle Unterkünfte",
  compare: {
    prevPeriod: "Vorheriger Zeitraum",
    prevYear: "Vorjahr",
    titlePrevPeriod: "Vergleich: vorheriger Zeitraum",
    titlePrevYear: "Vergleich: Vorjahr",
    inlinePrevPeriod: "vorheriger Zeitraum",
    inlinePrevYear: "Vorjahr",
  },
  summary: {
    currentPeriod: "Aktueller Zeitraum",
    paymentFilter: "Zahlungsfilter",
  },
  presets: {
    today: "Heute",
    yesterday: "Gestern",
    d7: "7 Tage",
    d30: "30 Tage",
    m3: "3 Monate",
    m6: "6 Monate",
    year: "1 Jahr",
  },
  payment: {
    all: "Alle Zahlungen",
    pending: "Ausstehend",
    paid: "Bezahlt",
    rejected: "Abgelehnt",
    refunded: "Erstattet",
    partial: "Teilzahlung",
  },
  kpi: {
    totalRevenue: "Umsatz im Zeitraum",
    arrivalRevenue: "Gesamtwert der Anreisen",
    revpar: "RevPAR",
    occupancyRate: "Auslastung",
    adr: "ADR",
    avgStay: "Durchschnittliche Aufenthaltsdauer",
    bookingWindow: "Buchungsvorlauf",
  },
  units: {
    days: " Tage",
  },
  chart: {
    thisPeriod: "Dieser Zeitraum",
    subtitle: "{current} · verglichen mit {compared} · {payment}",
  },
  channels: {
    directBookings: "Direktbuchungen",
    otaBookings: "OTA-Buchungen",
    bookingDetails: "Buchungsdetails",
    byChannel: "Nach Kanal",
    tableChannel: "Kanal",
    tableRevenue: "Umsatz",
    direct: "Direkt",
    ota: "OTA",
    noData: "Keine Daten für den gewählten Zeitraum",
  },
  a11y: {
    chartOf: "Diagramm von {label}",
    directVsOta: "Diagramm Direktbuchungen im Vergleich zu OTA",
  },
};
